import "../styles/css/admin-style.css";
import SuperAdminSearchTable from "../components/super-admin-management/SuperAdminSearchTable";
import YearlySettingsTable from "../components/yearly-settings/YearlySettingsTable";
import {useEffect, useState} from "react";
import {userService} from "../services/userService";
import eventEmitter from "../shared/eventEmitter";
import {EventEmitterTypes} from "../shared/eventEmitterEnum";
import {businessYearService} from "../services/businessYearService";

const NewYearSetupPage = () => {
    const [yearlySettingsData, setYearlySettings] = useState([])

    useEffect(() => {
        loadData();
    }, []);
    
    useEffect(() => {
        const refreshListener = () => {
            loadData();
        };

        eventEmitter.on(EventEmitterTypes.REFRESH_YEARLY_SETTINGS, refreshListener);
        return () => {
            eventEmitter.off(EventEmitterTypes.REFRESH_YEARLY_SETTINGS, refreshListener);
        };
    }, []);
    
    const loadData = () => {
        Promise.resolve(
            businessYearService.getBusinessYears()
        ).then(postRes => {
            setYearlySettings(postRes || []);
            return postRes;
        });
    }
    return (
        <div className="container-fluid ptCustom">
            <div className="row">
                <div className="col-12 my-2">
                    <div className="card shadow-sm rounded-lg">
                        <div className="card-body p-4">
                            <YearlySettingsTable settings={yearlySettingsData} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default NewYearSetupPage;
